export const excludeKeys = <T extends object>(state: T, keys: (keyof T)[]) => {
	const clone = { ...state };
	keys.forEach((key) => {
		delete clone[key];
	});
	return clone;
};
